
export function useOverlay(context, artikelnummer) {
    const artikelnummernString = sanitizeArtikelnummerString(artikelnummer);
    context.addEventListener("click", (event) => handleClickEvent(event, artikelnummernString, context));
}

function handleClickEvent(event, artikelnummer, context) {
    const target = event.target;
    if (target.closest(".warenkorb-button")) {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent("open-wk-overlay", {
            detail: {
                artikelnummer: artikelnummer,
                origin: target,
                itemListId: context.itemListId || undefined,
                itemListName: context.itemListName || undefined
            },
            bubbles: true
        }))
    }
}

export function sanitizeArtikelnummerString(artikelnummern) {
    return artikelnummern.replace(/[^A0-9,]/g, '')
}